import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import useClickAwayListener from '../../hooks/useClickAwayLitsner';
import { useAppState } from '../../contexts/appState';
import { CheckingValidComment, getCommentErrorMsg } from '../../lib/common';

const CommonPopup = ({ comment, setComment, handleCommentSubmit, handleClosePopup }) => {
  const [appState] = useAppState();
  const { popupObj } = appState;
  const { heading, subHeading, placeholder, popupType } = popupObj;
  const ref = useRef(null);
  const [haveSubmitted, setHaveSubmitted] = useState(false);

  useClickAwayListener(ref, () => {
    handleClosePopup();
  });

  const handleSubmit = async (e) => {
    document.body.style.overflow = 'unset';
    e.preventDefault();
    setHaveSubmitted(true);
    await handleCommentSubmit();
    setHaveSubmitted(false);
  };

  let enableSubmitButton = false;
  if (['reopenTicket', 'GrievanceRedressal'].includes(popupType)) {
    enableSubmitButton = CheckingValidComment(comment, 15);
  } else if (['UserGrievancePopup', 'postIssue'].includes(popupType)) {
    enableSubmitButton = CheckingValidComment(comment);
  }

  return (
    <section className="cs_modal csgrievance_pop">
      <div className="cs_modal_content cs_modal_animation cs_modal_up" ref={ref}>
        <div className="cs_modal_body pl-20 pr-20 pb-20">
          <div className="pop_csgrievance_header">
            <div className="csgrievance_headtxt popup-heading-div font15 fw600 color111 pt-25 ">
              {heading}
              <div
                className="modal_close csicon"
                onClick={() => handleClosePopup()}
                aria-label="Close Modal"
                type="button"
                tabIndex={0}
                role="button"
                onKeyDown={() => {}}
              />
            </div>
          </div>
          {subHeading && <div className="font12 fw400 color111 mt-5">{subHeading}</div>}
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            className="csgrievance_textarea font12 fw400 color111 mt-20"
            rows="4"
            cols="50"
            placeholder={placeholder}
          />
          {comment && !CheckingValidComment(comment) && comment.length > 3 && (
            <span className="colorEC4 font12 fw500">{getCommentErrorMsg(comment)}</span>
          )}
          <div className="csgrievance_btnbox">
            <button
              onClick={() => handleClosePopup()}
              type="button"
              className="csgrievance_button csgrievance_unfilled font15 fw500 color007 mt-20"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              type="button"
              disabled={!enableSubmitButton || haveSubmitted}
              className={`csgrievance_button ${
                !enableSubmitButton ? 'csgrievance_filled_disabled' : 'csgrievance_filled'
              } font15 fw500 colorFFF`}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommonPopup;

CommonPopup.propTypes = {
  comment: PropTypes.string,
  handleCommentSubmit: PropTypes.func,
  setComment: PropTypes.func,
  handleClosePopup: PropTypes.func,
};
